import { render } from "./CASIHighestScoreCheckboxInput.vue?vue&type=template&id=8a9e6f04&scoped=true"
import script from "./CASIHighestScoreCheckboxInput.vue?vue&type=script&lang=js"
export * from "./CASIHighestScoreCheckboxInput.vue?vue&type=script&lang=js"

import "./CASIHighestScoreCheckboxInput.vue?vue&type=style&index=0&id=8a9e6f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9e6f04"]])

export default __exports__